export const PAYMENT_SESSION_KEY = 'payment_session';